import {gemStore} from 'app/gemStore';
import {Nil} from 'app/interface';
import {NewHashState, NewHashStateData, NewState} from 'app/utils/urlStateElements/interfaces';

/**
 * Parses slash-separated hash path into component state objects keyed by component reference.
 * @param path
 * @param additionalKeys - extra keys to recognize beyond DOM-discovered component IDs
 * @return State object
 */
export function parseHashUrl(path: Nil<string>, additionalKeys?: string[]): NewState {
    if (!path) {
        return {};
    }

    const hashPath = path.replace(/^\//, '');
    if (!hashPath) {
        return {};
    }

    const keys = new Set([...getComponentsCid(), ...Object.keys(gemStore.getState()), ...(additionalKeys ?? [])]);
    const urlParts = hashPath.split('/');
    const states = urlParts.reduce<NewHashState>((newHashState, urlPart) => {
        const lastStateData = newHashState[newHashState.length - 1];
        const decodedPart = getDecodedCid(urlPart);
        if (keys.has(decodedPart)) {
            newHashState.push({key: decodedPart, state: []});
        } else if (lastStateData) {
            let lastStateItem = lastStateData.state[lastStateData.state.length - 1];
            if (!lastStateItem || Object.hasOwn(lastStateItem, 'value')) {
                lastStateItem = {key: urlPart};
                lastStateData.state.push(lastStateItem);
            } else {
                lastStateItem.value = urlPart;
            }
        }

        return newHashState;
    }, []);

    return states.reduce((newState: NewState, stateData: NewHashStateData) => {
        const statePart = stateData.state.reduce((state, item) => {
            return {
                ...state,
                [item.key]: item.value,
            };
        }, {});

        return {
            ...newState,
            [stateData.key]: statePart,
        };
    }, {});
}
function getComponentsCid() {
    const compCid: string[] = [];
    const compConf = document.querySelectorAll<HTMLElement>('.js-gem-json-config');
    for (const element of compConf) {
        const {cid, cidAlias} = element.dataset;
        if (cidAlias) {
            compCid.push(cidAlias);
        } else if (cid) {
            compCid.push(cid);
        }
    }

    return compCid;
}

function getDecodedCid(cId: string) {
    try {
        return decodeURIComponent(cId);
    } catch {
        console.warn('Cannot decode cId!');
        return cId;
    }
}
